import { useContext } from "react";
import { SectionContext } from "./context";

export const useSectionContext = () => useContext(SectionContext)